import React, { useContext, useLayoutEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

import Header from "./Header";
import Footer from "./Footer";
import ModalLoading from "./ModalLoading";
import ModalPriceList from "./heatmaps/ModalPriceList";
import { AppContext } from "../context/AppContext";
import NoPNOWarning from "./NoPNOWarning";

const Layout = () => {
  const { isUserDataLoading, showPNOWarning, setIsUserDataLoading } =
    useContext(AppContext);
  const { pathname } = useLocation();
  const isAppHub = /\/app\/?$/.test(pathname);

  return (
    <div>
      {isUserDataLoading && !isAppHub && <ModalLoading />}
      <ModalPriceList />

      <header className="header anchor__header">
        <Header />
      </header>
      <main className="content">
        {/* {showPNOWarning && <NoPNOWarning />} momentálně se tato zpráva o potřebě nastavení PNO a rozpočtu nepoužívá */}
        <Outlet />
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
};

export default Layout;
